import { Wording } from '@/types';

export const COOKING_WORDING_SE: Wording = {
  components_header_media_content: 'Matlagningsvideor',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Recept',
  components_header_text2: 'Blogg',
  components_header_members: 'Medlemmar',
  hero_text: 'Laga mat med passion, ät med glädje',
  hero_button_text: 'Börja laga mat idag',
  components_ressources_section_title: 'RESURSER',
  components_ressources_subheader_text: 'Alla resurser du behöver för att lära dig, laga mat och skapa bättre mat',
  components_ressources_span_text: 'Upptäck en rik samling videorecept, detaljerade matlagningsguider och expertinsikter om smakkombinationer, matpresentation och kulinarisk kreativitet.',
  components_ressources_card_1_title: 'Matlagningsinspiration',
  components_ressources_card_1_text: 'Bli inspirerad av kreativa recept och matlagningsvideor.',
  components_ressources_card_2_title: 'Matlagningskunskap',
  components_ressources_card_2_text: 'Lär dig grundläggande matlagningstekniker, smakkombinationer och grunderna i matparningar genom tydliga och praktiska guider.',
  components_ressources_link: 'Titta på videor',
  components_notes_and_google_title_1: 'Matlagningsutbildning',
  components_notes_and_google_title_2: 'Vardaglig matlagning',
  components_notes_and_google_title_3: 'Konsekventa matlagningskunskaper',
  components_review_google_text: 'Recensioner på Google',
  media_content_section_title: 'Matlagningsvideor',
  media_content_section_subheader_text: 'Utforska recept och steg-för-steg-matlagningsvideor.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Fler videor',
  text2_section_title: 'BLOGG',
  text2_section_subheader_text: 'Guider och artiklar',
  text2_section_button_more: 'Fler artiklar',
  components_text1_section_title: 'RECEPT',
  components_text1_subheader_text: 'Läckra recept för vardaglig matlagning',
  components_text1_span_text: 'Upptäck lättförståeliga recept utformade för vardagliga måltider, tydliga steg och fantastiska resultat.',
  components_text1_card_1_title: 'Börja din dag rätt',
  components_text1_card_1_text: 'Enkla och goda recept för att börja dagen med lätthet och smak.',
  components_text1_card_3_title: 'Smakrika lunchidéer',
  components_text1_card_3_text: 'Läckra lunchrecept som är enkla att tillaga och fulla av smak.',
  components_text1_card_2_title: 'Tröstande middagsrecept',
  components_text1_card_2_text: 'Varma, mättande middagsrecept perfekta för avkopplande kvällar hemma.',
  components_text1_link: 'Visa alla recept',
  components_footer_text: 'Lär dig bättre matlagning, skapa bättre mat: Ditt kök, din resa.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registreringsnummer',
  components_footer_legal: 'Rättslig',
  components_footer_terms: 'Villkor',
  components_footer_privacy: 'Integritetspolicy',
  button_load_more: 'Ladda mer',
  page_media_1_content_hero_text: 'Upptäck enkla matlagningsvideor för alla smaker',
  page_text1_hero_text: 'Recept',
  page_text1_section_title: 'Matlagningstips',
  page_text1_subheader_text: 'Recept',
  page_text2_hero_text: 'Vår blogg',
  page_text2_section_title: 'Blogg',
  page_text2_subheader_text: 'Guider och artiklar',
  enter_email_title: 'Ange din e-postadress för att fortsätta',
  enter_email_placeholder_email: 'E-post',
  enter_email_button_enter: 'Skriva in',
  components_login_success_text: 'Inloggningen lyckades!',
  components_card_link_media_content: 'Titta nu',
  components_card_link_text1_content: 'Visa recept',
  components_card_link_text2_content: 'Visa artikel',
};